export default "/fonts/SFProDisplay-Regular.ttf?6b109fecbc7563467e364a228c5106f0";